<template>
  <div
    v-masonry-tile
    class="ad1-box-card ads-grid item"
  >
    <el-card
      :key="item.key"
      class="ad1-box-card"
      :body-style="{ padding: '0px' }"
    >
      <div
        class="img-wrapper pointer"
        :style="{ 'background': !item || !item.file ? `url(/static/img/no-image.png) no-repeat center center / cover`: '' }"
        @click="viewAd"
      >
        <vue-load-image v-if="item && item.file">
          <img
            slot="image"
            class="image"
            :src="item.file.url_view | resizeImage(430, 287)"
            :data-src="item.file.url_view | resizeImage(430, 287)"
          >
          <div
            slot="preloader"
            v-loading="true"
            class="img-loading"
          >
            {{ $t('Loading ....') }}
          </div>
          <div slot="error">
            {{ $t('Network error') }}
          </div>
        </vue-load-image>
      </div>
      <div class="ad1-card-desc">
        <favorite
          v-if="!isAd"
          v-model="isFavorite"
          :res="'ads/favourite'"
          :entity-id="item.id"
          :entity-name="'ad_id'"
        />
        <div
          class="ad1-card-info pointer"
          @click="viewAd"
        >
          <span class="ad1-card-title">{{ item.name }}</span>
          <div class="bottom clearfix">
            <span
              class="ad1-card-price"
              :class="{'opacity-0': item.price <= 0}"
            >{{ item.price | formatMoney(0) }} {{ dataGet('currency.code', item) }}</span>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { dataGet } from '@fps/vue-toolkit/dist/util';
import mutations from '@/store/ads/ads.mutationlist';
import Favorite from '@/components/Core/Favorite';

export default {
  components: {
    Favorite,
  },

  props: {
    item: {
      type: Object,
      default: () => {},
    },
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
    index: {}, isAd: {}, state: {},
  },

  data() {
    return {
      favUser: null,
    };
  },

  computed: {
    isFavorite: {
      get() {
        return this.favUser;
      },
      set(val) {
        this.favUser = val;
        if (this.state) {
          this.$store.commit(
            mutations.UPDATE_AD,
            {
              ...this.item,
              favoring_logged_in_user: this.favUser,
            });
        }
      },
    },
    ...mapState({
      isMobile: state => state.isMobile,
      url: state => state.config ? state.config.apiUrl.replace('/api', '') : '',

    }),
  },

  watch: {
    item(val) {
      this.favUser = val ? val.favoring_logged_in_user : null;
    },
  },

  mounted() {
    this.favUser = this.item ? this.item.favoring_logged_in_user : null;
  },

  methods: {
    dataGet(path, item, defaultValue) {
      return dataGet(path, item, defaultValue);
    },
    viewAd() {
      this.$router.push({ name: 'Ad', params: { id: this.item.id } });
    },
  },
};
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Ads/AdsItem.vue